import V1 from './V1';
import {VersionVariants} from '@jobseeker/lotus/enums';
import type {TextFieldProps as MuiTextFieldProps} from '@mui/material';

type MuiProps = Pick<
  MuiTextFieldProps,
  | 'onChange'
  | 'sx'
  | 'label'
  | 'value'
  | 'name'
  | 'error'
  | 'onBlur'
  | 'onFocus'
>;
export interface OptionType {
  value: string | number;
  label: string;
  cluster?: string;
}
export interface SearchInputProps extends MuiProps {
  placeholder: string;
  variant: string | VersionVariants;
  options: OptionType[];
  onSelect?: (e: any) => void;
  maxCharLength?: number;
  hiristColor?: boolean;
  setDialogOpen?: any;
  formikName?: string;
  clusterValue?: string;
  clusterOptions?: any;
}

let componentMap: {[key: string]: any} = {};

componentMap[VersionVariants.VERSION_ONE] = V1;

const Component = (props: SearchInputProps) => {
  let Component;
  if (Object.keys(componentMap).includes(props.variant)) {
    Component = componentMap[props.variant];
  } else {
    Component = componentMap[VersionVariants.VERSION_ONE];
  }
  return <Component {...props} />;
};

export default Component;
